import type { Provider } from '@angular/core';

import { BoostersGiftsCsvInsightService } from '#modules/statistics-boosters/services/csv/boosters-gifts.service';
import { BoostersReviewsCountCsvInsightV2Service } from '#modules/statistics-boosters/services/csv/boosters-reviews-count-v2.service';
import { BoostersScanCountCsvInsightV2Service } from '#modules/statistics-boosters/services/csv/boosters-scan-count-v2.service';
import { FollowersCsvInsightsV2Service } from '#modules/statistics-e-reputation/services/csv/followers-v2.service';
import { PlatformsRatingsCsvInsightsService } from '#modules/statistics-e-reputation/services/csv/platforms-ratings.service';
import { ReviewsRatingsEvolutionCsvInsightsService } from '#modules/statistics-e-reputation/services/csv/reviews-ratings-evolution.service';
import { ReviewsRatingsTotalCsvInsightsService } from '#modules/statistics-e-reputation/services/csv/reviews-ratings-total.service';
import { SemanticAnalysisDetailsCsvInsightsService } from '#modules/statistics-e-reputation/services/csv/semantic-analysis-details-csv-insights.service';
import { SemanticAnalysisTopicsCsvInsightsService } from '#modules/statistics-e-reputation/services/csv/semantic-analysis-topics-csv-insights.service';
import { GmbVisibilityCsvInsightsService } from '#modules/statistics-seo/services/csv/gmb-visibility.service';
import { KeywordsCsvInsightsServiceV2 } from '#modules/statistics-seo/services/csv/keywords-csv-insights-v2.service';
import { TopKeywordSearchImpressionsService } from '#modules/statistics-seo/services/csv/top-keyword-serach-impressions.service';
import { PublicationsCsvInsightsV3Service } from '#modules/statistics-social-networks/services/csv/publications-v3.service';
import { StoryCsvInsightsService } from '#modules/statistics-social-networks/services/csv/stories.service';

export const DOWNLOAD_CSV_INSIGHTS_PROVIDERS: Provider[] = [
    StoryCsvInsightsService,
    BoostersGiftsCsvInsightService,
    FollowersCsvInsightsV2Service,
    TopKeywordSearchImpressionsService,
    KeywordsCsvInsightsServiceV2,
    PublicationsCsvInsightsV3Service,
    GmbVisibilityCsvInsightsService,
    ReviewsRatingsEvolutionCsvInsightsService,
    ReviewsRatingsTotalCsvInsightsService,
    SemanticAnalysisDetailsCsvInsightsService,
    SemanticAnalysisTopicsCsvInsightsService,
    BoostersReviewsCountCsvInsightV2Service,
    BoostersScanCountCsvInsightV2Service,
    PlatformsRatingsCsvInsightsService,
];
